function reExecuteScripts(scriptSelector) {
    document.querySelectorAll(scriptSelector).forEach(oldScriptTag => {
        if (oldScriptTag.dataset.executed === 'executed') {
            // console.log('already executed once');
            return;
        }
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        newScriptTag.dataset.executed = 'executed';
    });
}

function findAndExecuteQuickviewBlock2({ camouflageProductBlockSelector }) {
    let productBlockFound = false;
    let lapsedTime = 0;
    let interval = 200;
    const timer = setInterval(() => {
        // console.log("setInterval", lapsedTime);
        try {
            const blockFound = document.querySelector(camouflageProductBlockSelector);
            if (blockFound) {
                productBlockFound = true;
                reExecuteScripts(camouflageProductBlockSelector);
            } else {
                lapsedTime += interval;
            }
        } catch (error) {
            console.error(error);
            clearInterval(timer);
        }

        if (lapsedTime > 3500 || productBlockFound) {
            // console.log('clearing interval', lapsedTime, productBlockFound);
            clearInterval(timer);
        }
    }, 200);
}

const getSwatchConfig = ({ product, optionToHide, container }) => {
    const swatchSelectorConfig = {
        container: container || `#main-collection-product-grid .product-index[data-product-id="${product.id}"], .product-recommendations .product-index[data-product-id="${product.id}"]`,
        swatches: `ul.color.options li`,
        value_attribute: 'data-option-title',
        hide_class: 'hide-oos-disable',
    };
    return swatchSelectorConfig;
};

const executeHideSoldOutOptionsFromSingleProductGridItem2 = ({ hide_oos_m_settings, product, optionToHide = 'Color', callback, container }) => {
    // console.log("executeHideSoldOutOptionsFromSingleProductGridItem2:start");
    const swatchSelectorConfig = getSwatchConfig({ product, optionToHide, container });

    const hide_oos_variant_qty = product.hide_oos_variant_qty || [];
    const productMetafields = product.metafields;
    let hide_variants_options_arr = [];
    if (productMetafields) {
        hide_oos_m_settings = { ...hide_oos_m_settings || {}, ...productMetafields };
        hide_variants_options_arr = productMetafields.hide_variants_options || hide_variants_options_arr;
    }

    let availableVariants = product.variants.filter(v => v.available);
    if (window.CAMOUFLAGEE && window.CAMOUFLAGEE.getHoosObj) {
        const hoosObj = window.CAMOUFLAGEE.getHoosObj({
            hide_oos_m_settings: hide_oos_m_settings,
            hide_oos_variant_qty: hide_oos_variant_qty,
            hide_oos_extras: window.hide_oos_extras,
            hide_variants_options_arr: hide_variants_options_arr,
            product: product,
            no_hoos_obj: true,
        });
        hoosObj.product = hoosObj.product || product;
        availableVariants = window.CAMOUFLAGEE.getAvailableVariants({ hoosObj });
    }

    const options = product.options;
    let availableOptions = {};
    for (let i = 0; i < options.length; i++) {
        const temp = new Set();
        for (const v of availableVariants) {
            temp.add(v.options[i]);
        }
        availableOptions[options[i]] = [...temp];
    }
    // console.log({availableVariants, availableOptions});

    if (typeof callback === "function") {
        callback({ availableVariants, availableOptions, product });
        return;
    }

    if (typeof window.camouflageProductGridSwatches === "function") {
        window.camouflageProductGridSwatches({ availableVariants, availableOptions, product });
    } else {
        const container = document.querySelector(swatchSelectorConfig.container);
        // console.log(container, swatchSelectorConfig.container);
        // console.log(availableOptions);
        if (!container) {
            return;
        }

        const availableCurrentVariantOptions = availableOptions[optionToHide] || availableOptions[optionToHide.toLowerCase()];
        const elements = container.querySelectorAll(swatchSelectorConfig.swatches);
        if (!elements.length) {
            return;
        }
        for (const elem of elements) {
            const optionValue = elem.getAttribute(swatchSelectorConfig.value_attribute);
            // console.log({optionValue, availableCurrentVariantOptions, p: product.title});
            if (optionValue && !availableCurrentVariantOptions.includes(optionValue)) {
                // console.log(`${optionValue} not available in ${product.title}`);
                elem.classList.add(swatchSelectorConfig.hide_class);
            }
        }
    }
};

const hideSoldOutOptionsFromProductGrid2 = async ({ col_handle = 'all', optionToHide = 'Color', callback }) => {
    const response = await fetch(`/collections/${col_handle}?view=camouflage`);
    if (!response.ok) {
      return;
    }

    const data = await response.json();
    window.hoosObj = null;
    let hide_oos_m_settings = data.hide_oos_m_settings;
    for (const product of data.products) {
        executeHideSoldOutOptionsFromSingleProductGridItem2({
            hide_oos_m_settings,
            product,
            optionToHide,
            callback, // if hideSoldOutOptionsFromProductGrid2 method is called from liquid directly, it may pass a callback function
        });
    }
};

window.hideSoldOutOptionsFromProductGrid2 = hideSoldOutOptionsFromProductGrid2;
window.executeHideSoldOutOptionsFromSingleProductGridItem2 = executeHideSoldOutOptionsFromSingleProductGridItem2;
window.findAndExecuteQuickviewBlock2 = findAndExecuteQuickviewBlock2;